import React, { useEffect, useState } from "react";
/* CRITICAL: Imported Link from react-router-dom to safely manage environments base paths */
import { useLocation, Link } from "react-router-dom";
// Services & Helpers
import { getLocalStorageData } from "../services/localStorageService";

function Footer() {

  return (
      <section className="wed-hom-footer">
        <div className="container">
          <div className="row foot-supp">
            <h2><span>Free support:</span> +91 70210 57077 &nbsp;&nbsp;|&nbsp;&nbsp;
              <span>Email:</span> support@vikasmandalmulund.com</h2>
              <p className="time_note">Evening 4:30 to 8:30, Monday to Saturday (Not available on Sundays and public holidays)</p>
          </div>
          <div className="row wed-foot-link wed-foot-link-1">
            <div className="col-md-4">
              <h4>Get In Touch</h4>
              <p>Address: 101, Jai Laxminarayan Society, Lokmanya Tilak Marg, Mulund(E) Mumbai - 400081</p>
              <p>Phone: <a href="tel:+917904462944">+91 7021057077</a></p>
              <p>Email: <a href="mailto:info@example.com">support@vikasmandalmulund.com</a></p>
            </div>

            <div className="col-md-5">
              <h4>HELP &amp; SUPPORT</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/AboutUs">About Us</Link></li>
                <li><Link to="/ManagementTeam">Management</Link></li>
                <li><Link to="/Events">Events</Link></li>
                <li><Link to="/ContactUs">Contact Us</Link></li>
                 <li><Link to="/TermsConditions">Terms & Conditions</Link></li>
                 <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
                 <li><Link to="/ChildSafetyStandards">Child Safety Standards & CSAE Policy</Link></li>
              </ul>
            </div>

            <div className="col-md-3 fot-soc">
              <h4>SOCIAL MEDIA</h4>
              <ul>
                {/* Keep <a> tags ONLY for external links/dead hashes (#!) outside your app */}
                <li>
                  <Link target="_blank" to="https://www.instagram.com/vmmulund/">
                    <img src={`${process.env.PUBLIC_URL}/assets/imgs/instagram.png`} alt="LinkedIn" loading="lazy"/>
                  </Link>
                </li>
                <li>
                  <Link target="_blank" to="https://x.com/vmmulund">
                    <img src={`${process.env.PUBLIC_URL}/assets/imgs/twitter.png`} alt="Twitter" loading="lazy"/>
                  </Link>
                </li>
                <li>
                  <Link target="_blank" href="https://www.facebook.com/vikasmandalmulund">
                    <img src={`${process.env.PUBLIC_URL}/assets/imgs/facebook.png`} alt="Facebook" loading="lazy"/>
                  </Link>
                </li>
                <li>
                  <Link target="_blank" to="https://www.youtube.com/@vmm_mulund">
                    <img src={`${process.env.PUBLIC_URL}/assets/imgs/yotube.png`} alt="YouTube" loading="lazy"/>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="cr">
          <div className="container">
            <div className="row">
              <p>Copyright © <span id="cry">2026</span> <a href=" https://vikasmandalmulund.com/"> vikasmandalmulund.com</a> All rights
                reserved.</p>
            </div>
          </div>
        </div>
      </section>
  )
      ;
}

export default Footer;